module.exports = __webpack_public_path__ + "img/setup_guidline4.8f3a4743.png";